import BaseApi from "../base";

export default class User extends BaseApi {

}

